import {Record as record} from 'immutable';

import {fields} from '../../helpers/LinkMapper';
import {getDefaults} from '../../helpers/Records';

import ValidationMixin from '../ValidationMixin';
import validators from '../../validation';

const schema = {
    currentPassword: [fields.string],
    newPassword: [fields.string],
};

class PasswordChange extends record(getDefaults(schema)) {
    getSchema() {
        return {
            currentPassword: validators.passwordEntry(),
            newPassword: validators.passwordCreate().required(),
        };
    }
}

Object.assign(PasswordChange.prototype, ValidationMixin);

export default PasswordChange;
